import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import styled from 'styled-components/macro';

import Logo from 'shared/icons/modsy-logo.svg';

import { royalBlue, white } from 'web-ui-kit/colors';
import { Flex } from 'web-ui-kit/containers';
import { H7 } from 'web-ui-kit/heading';
import { Image } from 'web-ui-kit/image';

export default class PageFooter extends React.Component {
  render () {
    return (
      <Container>
        <LogoContainer>
          <Image src={Logo} width={'162px'} />
        </LogoContainer>

        <FooterContent>
          <Row>
            <SectionContainer>
              {this.renderModsyLinks()}
            </SectionContainer>
            <SectionContainer>
              {this.renderAboutLinks()}
            </SectionContainer>
          </Row>

          <Row>
            <SectionContainer>
              {this.renderResources()}
            </SectionContainer>
            <SectionContainer>
              {this.renderSocialMedia()}
            </SectionContainer>
          </Row>
        </FooterContent>
      </Container>
    );
  }

  renderModsyLinks = () => {
    return (
      <Section>
        <Title>Modsy</Title>
        <InAppLink to='/stylequiz'>
          <LinkText>Style Quiz</LinkText>
        </InAppLink>
        <ExternalLink href='http://blog.modsy.com/'>
          <LinkText>Blog</LinkText>
        </ExternalLink>
        <ExternalLink href='https://blog.modsy.com/real-stories/'>
          <LinkText>Examples</LinkText>
        </ExternalLink>
        <InAppLink to='/share'>
          <LinkText>Refer a Friend</LinkText>
        </InAppLink>
        <ExternalLink href='http://www.modsy.com/modsy-gift-cards/'>
          <LinkText>Gift Cards</LinkText>
        </ExternalLink>
      </Section>
    );
  }

  renderAboutLinks = () => {
    return (
      <Section>
        <Title>About</Title>
        <ExternalLink href='https://jobs.gusto.com/boards/modsy-3eb425d3-0069-4488-a57f-ce40d2611bfe'>
          <LinkText>Careers</LinkText>
        </ExternalLink>
        <ExternalLink href='/about-us'>
          <LinkText>Our Story</LinkText>
        </ExternalLink>
      </Section>
    );
  }

  renderResources = () => {
    return (
      <Section>
        <Title>Support</Title>
        <ExternalLink to='/faqs/'>
          <LinkText>FAQs</LinkText>
        </ExternalLink>
        <ExternalLink href='mailto:hello@modsy.com' target='_blank'>
          <LinkText>Contact Us</LinkText>
        </ExternalLink>
        <InAppLink to='/terms-of-service'>
          <LinkText>Terms of Service</LinkText>
        </InAppLink>
        <InAppLink to='/privacy-policy'>
          <LinkText>Privacy</LinkText>
        </InAppLink>
      </Section>
    );
  }

  renderSocialMedia = () => {
    return (
      <Section>
        <Title>Follow Us</Title>
        <ExternalLink href='http://facebook.com/modsydesign' target='_blank' rel='noopener noreferrer'>
          <LinkText>Facebook</LinkText>
        </ExternalLink>
        <ExternalLink href='http://twitter.com/modsy' target='_blank' rel='noopener noreferrer'>
          <LinkText>Twitter</LinkText>
        </ExternalLink>
        <ExternalLink href='http://instagram.com/modsydesign' target='_blank' rel='noopener noreferrer'>
          <LinkText>Instagram</LinkText>
        </ExternalLink>
        <ExternalLink href='http://pinterest.com/modsy' target='_blank' rel='noopener noreferrer'>
          <LinkText>Pinterest</LinkText>
        </ExternalLink>
      </Section>
    );
  }
}

/**
 * Styles
 */
const Container = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 32px;
  margin: 40px 0;

  @media screen and (min-width: 769px) {
    flex-direction: row;
  }

  @media screen and (min-width: 1024px) {
    margin: 96px 0;
  }
`;
Container.displayName = 'Container';

const FooterContent = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  width: 100%;
  max-width: 600px;

  margin-top: 25px;

  @media screen and (min-width: 512px) {
    flex-direction: row;
    align-items: flex-start;
  }

  @media screen and (min-width: 1024px) {
    margin-top: 0;
  }
`;
FooterContent.displayName = 'FooterContent';

const LogoContainer = styled(Flex)`
  flex-direction: column;
  justify-content: left;
  margin-left: 38px;
  margin-right: 50px;

  @media screen and (min-width: 512px) {
    margin-left: 24px;
  }

  @media screen and (min-width: 1024px) {
    margin-left: 0;
  }
`;
LogoContainer.displayName = 'LogoContainer';

const Row = styled(Flex)`
  flex-direction: row;
  justify-content: space-evenly;
  width: 90%;
`;
Row.displayName = 'Row';

const SectionContainer = styled(Flex)`
  width: 40%;
`;
SectionContainer.displayName = 'SectionContainer';

const Section = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 32px;
`;
Section.displayName = 'Section';

const Title = styled(H7)`
  color: ${royalBlue};
  font-weight: 600;
  margin-bottom: 15px;
`;
Title.displayName = 'Title';

const InAppLink = styled(ReactRouterLink)`
  color: ${white};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
};
`;
InAppLink.displayName = 'InAppLink';

const LinkText = styled(H7)`
  color: ${royalBlue};
`;
LinkText.displayName = 'LinkText';

const ExternalLink = styled.a`
  color: ${white};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
ExternalLink.displayName = 'ExternalLink';
